import { Component, Vue } from 'vue-property-decorator';

import Loader from '@/components/Loader/index.vue';

import { validationMixin } from 'vuelidate'

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

library.add(faTrashAlt);

@Component({
	components: {
		Loader,
	},
	mixins: [validationMixin],
})
export default class ModalConfirm extends Vue {
	submittable = true;
	saving = false;

	open() {
		this.$bvModal.show('modal-confirm');
	}

	async submit() {
		console.info('submit');
	}

	async preSubmit() {
		this.saving = true;
		await this.submit();
		this.$bvModal.show('modal-confirm');
		(this.$router as any).go();
		this.saving = false;
	}
}
